import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconEvent = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M.75 5.25a1.5 1.5 0 011.5-1.5h19.5a1.5 1.5 0 011.5 1.5v16.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V5.25z",
      stroke: color,
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M.75 9.75h22.5",
      stroke: color,
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.75 6V.75M17.25 6V.75",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M11.564 12.682a.49.49 0 01.872 0l1.012 2.042c.071.142.208.24.365.262l2.273.33a.476.476 0 01.269.814l-1.65 1.6a.476.476 0 00-.138.42l.389 2.255a.473.473 0 01-.194.467.49.49 0 01-.511.035l-2.024-1.059a.492.492 0 00-.454 0l-2.024 1.06a.49.49 0 01-.511-.036.473.473 0 01-.194-.467l.389-2.255a.476.476 0 00-.138-.42l-1.65-1.6a.476.476 0 01.269-.815l2.272-.329a.484.484 0 00.366-.262l1.012-2.042z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconEvent.displayName = "IconEvent";

export { IconEvent };
